import { FC, ReactNode } from 'react';
import { ContentResponse } from '../types/shared';
import { BildfilImageResponse } from '../types/images';

interface IBildfil {
  contentResponse: ContentResponse;
}

const Bildfil: FC<IBildfil> = ({ contentResponse }): ReactNode => {
  const contentResponseImage = contentResponse.content as BildfilImageResponse;

  return (
    <img
      src={contentResponseImage.relativeSourceUrl}
      alt={contentResponseImage.altText ?? ''}
    />
  );
};

export default Bildfil;
